var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"rating",attrs:{"data-testId":`${_vm.testId}-vignette_rating`}},[_c('span',{staticClass:"rating__star"},[_c('i',{staticClass:"si",class:_vm.ratingClass})]),_c('span',{staticClass:"rating__reviewsCount"},[_vm._v(_vm._s(_vm.reviewsCount))])])
}
var staticRenderFns = []

export { render, staticRenderFns }